import { Component, OnDestroy, OnInit } from '@angular/core';
import { EventsService, UtilService, VariablesService } from '../../../shared/services';

@Component({
  selector: 'app-sip-dock',
  templateUrl: './sip-dock.component.html',
  styleUrls: ['./sip-dock.component.scss']
})
export class SipDockComponent implements OnInit, OnDestroy {

  constructor(
    public vars: VariablesService,
    public util: UtilService,
    public events: EventsService
  ) {
  }

  ngOnInit(): void {
  }

  redirect() {
    this.events.sendSystemEvent({
      eventName: 'give_monthly_new',
      page_name: this.vars.pageName,
      info_1: 'position',
      info_2: 'dock',
      info_3: 'impact'
    }).subscribe(_ => _);
    this.util.redirectWithUTM('new/sip', { utm_term: 'browse', utm_content: 'dock' });
    this.util.scrollToTop();
  }

  ngAfterViewInit() {
    // if (this.util.isBrowser) {
    //   setTimeout(() => {
    //     document.querySelector('footer').classList.add('mb-50');
    //   }, 900);
    // }
  }

  ngOnDestroy(): void {
    // if (this.util.isBrowser) {
    //   document.querySelector('footer').classList.remove('mb-50');
    // }
  }

}
